import './EndChatPrompt.css';
import React from 'react';
import {useTranslation} from "react-i18next";
function EndChatPrompt ({closeSelected}) {
    const {t} = useTranslation();
    
    return <>
        <div className="session-container">
            <strong>{t('endChatPrompt')}</strong>

            <div className="session-btn-container">
                <button onClick={() => closeSelected(false)} className="session-btn">
                    {t('continueChat')}
                </button>
                <button onClick={() => closeSelected(true)} className="session-btn session-btn-main">
                    {t('endChat')}
                </button>
            </div>
        </div>
    </>
}
export default EndChatPrompt;
